// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1776150264913
      var cssReload = require("/root/workspace/OKEY-front_sY8I/node_modules/_mini-css-extract-plugin@0.9.0@mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  